import { DotsSixVertical } from "@phosphor-icons/react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export function SortableEditorItem({ id, children, testPrefix }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
  const style = { transform: CSS.Transform.toString(transform), transition };
  return (
    <div className="sortable-editor-item" ref={setNodeRef} style={style}>
      <button
        className="drag-handle"
        type="button"
        aria-label="Drag to reorder"
        data-testid={`${testPrefix}-${id}`}
        {...attributes}
        {...listeners}
      >
        <DotsSixVertical aria-hidden="true" size={19} weight="bold" />
      </button>
      {children}
    </div>
  );
}